/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Stage_NameInputs */

const cs_pipelines_stage_name = /** @type {(inputs: Pipelines_Stage_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název fáze`)
};

const en_pipelines_stage_name = /** @type {(inputs: Pipelines_Stage_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stage name`)
};

/**
* | output |
* | --- |
* | "Stage name" |
*
* @param {Pipelines_Stage_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_stage_name = /** @type {((inputs?: Pipelines_Stage_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Stage_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_stage_name(inputs)
	return cs_pipelines_stage_name(inputs)
});